import React from "react";
import "./top-listing-headers.css";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";
import SingleDropdown from "../../singleDropdown/SingleDropdown";

interface ListingTopHeaderProps {
  PageHeading?: string;
  className?: string;
  Count?: number;
  ButtonName?: string;
  handleTabChange?: (value: string) => void;
  filterOptions?: { title: string; count: number }[];
  activeTab?: string;
  menuItems?: any[];
  handleSort?: (sortDirection: "asc" | "desc") => void; // ✅ Fix here
  currentSortDirection?: "asc" | "desc";
  onClick?: () => void;
  showSortDirection?: boolean;
  showFilter?: boolean;
  disableTabs?: boolean;
  showButton?: boolean;
}

const PaymentTopHeader: React.FC<ListingTopHeaderProps> = ({
  PageHeading,
  className = "",
  Count,
  ButtonName,
  handleTabChange,
  filterOptions,
  activeTab,
  menuItems,
  handleSort,
  currentSortDirection,
  onClick,
  showSortDirection = true,
  showFilter = true,
  disableTabs = true,
  showButton = true,
}) => {
  const handleSortChange = () => {
    const newDirection = currentSortDirection === "asc" ? "desc" : "asc";
    handleSort(newDirection);
  };
  return (
    <div className={`top-listing-header ${className}`}>
      <div className="top-listing-header-top">
        <H2
          text={`${PageHeading || ""}`}
        />
        {ButtonName && showButton && <SimpleButton label={ButtonName} onClick={onClick} />}
      </div>

      <div className="top-listing-header-filters">
        {showFilter && (
          <div className="filter-options">
            {filterOptions.map((option, index) => (
              <button
                key={index}
                className={`filter-option${
                  activeTab === option.title ? " filter-option-active" : ""
                }
                ${disableTabs ? " disabled" : ""}`}
                onClick={() => handleTabChange(option.title)}
                
              >
                {option.title} ({option.count})
              </button>
            ))}
          </div>
        )}
        {showSortDirection && (
          <div className="payment-header-actions">
            <SingleDropdown
              triggerText="All Payments"
              triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
              triggerIconPosition="right"
              menuItems={menuItems}
            />

            <div className="search-sort-container">
              <div className="sort-button" onClick={handleSortChange}>
                <span className="sort-text">Sort by: A-Z</span>
                <SortIcon />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentTopHeader;
